import { FlexBtnProps } from "./flex-button-types";
import "./style.css";

const FlexButtons = ({ className, children }: FlexBtnProps) => {
  return <div className={`d-flex flex-button ${className}`}>{children}</div>;
};

export default FlexButtons;
